import { InlineInput } from '@/components/ui/inline-input';
import { toEhrPatientSearchResultView } from '@/composition/adapters/to-ehr-patient-search-result-view';
import { EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH } from '@heidi/integrations/ehr';
import { type PatientSearchComboboxHost } from '@heidi/patients';
import { Loader } from '@heidi/snowflake-ui/loader';

import { emitPatientProfileSurfaceEvent } from '../patient-profile/usePatientProfileHost';

/** Binds the search combobox to the app input, loader, and EHR adapter. */
export function usePatientSearchComboboxHost(): PatientSearchComboboxHost {
  return {
    InlineInput,
    Loader,
    adaptEhrResult: toEhrPatientSearchResultView,
    ehrMinQueryLength: EHR_PATIENT_SEARCH_MIN_QUERY_LENGTH,
    emitSurfaceEvent: emitPatientProfileSurfaceEvent,
  };
}
